import type { Paths } from '@/data/tasks'
import { useAuth } from '@/store/auth'
import { useHousehold } from '@/store/household'

/** The household id and uid every write needs. Only valid once both stores are ready. */
export function usePaths(): Paths {
  const uid = useAuth((s) => s.user?.uid ?? '')
  const hid = useHousehold((s) => s.hid ?? '')
  return { hid, uid }
}

/** The other member's uid and name, if they have joined. */
export function useOther(): { uid: string; name: string } | null {
  const uid = useAuth((s) => s.user?.uid ?? '')
  const members = useHousehold((s) => s.household?.members)
  if (!members) return null
  const entry = Object.entries(members).find(([k]) => k !== uid)
  return entry ? { uid: entry[0], name: entry[1].name } : null
}

export function useMembers(): Record<string, string> {
  const members = useHousehold((s) => s.household?.members)
  const out: Record<string, string> = {}
  if (members) for (const [uid, m] of Object.entries(members)) out[uid] = m.name
  return out
}
